export const danismaKuruluData = [
    {
        firstName: "Mahmut",
        lastName: "AYDIN",
        academicTitle: "Prof. Dr.",
        university: "Samsun Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/mahmut-aydin.png"
    },
    {
        firstName: "Ahmet Hakkı",
        lastName: "TURABİ",
        academicTitle: "Prof. Dr.",
        university: "Amasya Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/ahmet-hakki-turabi.png"
    },
    {
        firstName: "Harun",
        lastName: "ÇİFTÇİ",
        academicTitle: "Prof. Dr.",
        university: "Çankırı Karatekin Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/harun-ciftci.png"
    },
    {
        firstName: "Ali Osman",
        lastName: "ÖZTÜRK",
        academicTitle: "Prof. Dr.",
        university: "Hitit Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/ali-osman-ozturk.png"
    },
    {
        firstName: "Ahmet Hamdi",
        lastName: "TOPAL",
        academicTitle: "Prof. Dr.",
        university: "Kastamonu Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/ahmet-hamdi-topal.png"
    },
    {
        firstName: "Yavuz",
        lastName: "ÜNAL",
        academicTitle: "Prof. Dr.",
        university: "Ondokuz Mayıs Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/yavuz-unal-1.jpg"
    },
    {
        firstName: "Orhan",
        lastName: "BAŞ",
        academicTitle: "Prof. Dr.",
        university: "Ordu Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/orhan-bas-1.jpg"
    },
    {
        firstName: "Şakir",
        lastName: "TAŞDEMİR",
        academicTitle: "Prof. Dr.",
        university: "Sinop Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/sakir-tas-demir.png"
    },
    {
        firstName: "Fatih",
        lastName: "YILMAZ",
        academicTitle: "Prof. Dr.",
        university: "Tokat Gaziosmanpaşa Üniversitesi",
        url: "#",
        imageUrl: "/assets/danismaKurulu/fatih-yilmaz.png"
    }
];